import React from "react";

/**
 * PushToTalkButton
 * Tap-to-toggle recording button.
 * First tap starts listening; second tap stops and shows transcript.
 * Uses a single onClick handler — no hold/mousedown/touchstart behavior.
 */
export function PushToTalkButton({ isListening, onPress, disabled }) {
  const idleLabel = "Tap to Speak";
  const activeLabel = "Listening… Tap to Stop";

  return (
    <div className="ptt-container">
      <button
        className={`ptt-button ${isListening ? "ptt-recording" : ""} ${disabled ? "ptt-disabled" : ""}`}
        onClick={onPress}
        disabled={disabled}
        aria-label={isListening ? activeLabel : idleLabel}
        aria-pressed={isListening}
      >
        {/* Pulse rings when recording */}
        {isListening && (
          <>
            <span className="ptt-ring ptt-ring-1" />
            <span className="ptt-ring ptt-ring-2" />
          </>
        )}

        {/* Microphone icon (idle) / Stop icon (recording) */}
        <span className="ptt-icon">
          {isListening ? (
            <svg viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="6" width="12" height="12" rx="2" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="9" y="2" width="6" height="12" rx="3" />
              <path d="M5 10a7 7 0 0 0 14 0" />
              <line x1="12" y1="19" x2="12" y2="22" />
              <line x1="9" y1="22" x2="15" y2="22" />
            </svg>
          )}
        </span>
      </button>

      <p className="ptt-label">
        {isListening ? (
          <span className="ptt-label-recording">
            <span className="ptt-dot" />
            {activeLabel}
          </span>
        ) : (
          idleLabel
        )}
      </p>
    </div>
  );
}
